
import { defineComponent, ref, inject, reactive,computed, toRefs } from "vue";
import Swal from 'sweetalert2'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { Modal } from 'ant-design-vue';

interface FormState {
  id: string;
  name: string;
  file: string;
  description: string
}

const initialState = {
  id:"",
  name: "",
  file: "",
  description: ""
};

export default defineComponent({
   props: {
    title: {
      type: String,
      default: "Form",
    },
    data: {
      type: Object,
    },
    isNew: {
      type: Boolean,
    },
    prop_errors_obj: {
     type: Object,
    },
  },
  setup(props) {
    /* DATA */
    const store = useStore()
    const router = useRoute()
    const form = reactive<FormState>({...initialState})
    const file_name = ref<any>('')
    const errors_obj = ref(props.prop_errors_obj)
    const visible = ref(false);
    const document = inject<any>('document');
    const acceptedFiles = ref<Array<string>>(['.pdf'])
    const form_action = ref('save');
    const invoice = inject<any>('invoice')
    const id = ref(0)
    const api_url = process.env.VUE_APP_URL
    const loading = ref(false)
    /* METHODS */

    const create = () => {
      Object.assign(form, initialState);
      visible.value = true;
      form_action.value = 'save'
    };

    const edit = (record: any) => {
      const {
        id,
        name,
        description
      } = toRefs(form)
      id.value = record.id
      name.value = record.name
      description.value = record.description
     
      visible.value = true
      form_action.value = 'update'
    }

    const handlefile = (e:any) => {
       form.file = e.target.files[0]
    };

    const cancel = () => {
      visible.value = false
    };

    const save = () => {
      loading.value = true
      form_action.value == 'save' ? addFile(form) : updateFile(form)
    }

    const addFile = async (payload: any) => {
      if (isNew.value) {
        if(form.file!='' && form.name != ''){
          invoice.invoice_files.push({
            id: id.value++,
            name: form.name,
            file: form.file,
            description: form.description
          })
          visible.value = false
          loading.value = false
        }else{
          Modal.error({
              title: 'Error',
              content: "File Name and File are required",
          })
          loading.value = false
        }
      } else {
        const formData = new FormData();
        formData.append('file', form.file)
        formData.append('name', form.name)
        formData.append('invoice_id', invoice.id)
        formData.append('description', form.description)

        store.dispatch("InvoiceFile/store", formData).then((response) => {
          visible.value = false
          loading.value = false
          invoice.invoice_files.push({
            id: response.data.id,
            invoice_id: response.data.invoice_id,
            name: form.name,
            description: form.description
          })
        }).catch((err) => {
          loading.value = false
        })
      }
    }

    const updateFile = (payload: any) => {

      let id = form.id

      if(isNew.value == true){
        invoice.invoice_files.find(function (value:any, key:any) {
        
          if (value.id == id) {
            if(form.name!=''){
              invoice.invoice_files[key] =  Object.assign({}, form);
              visible.value = false
            }else{
              Modal.error({
                  title: 'Error',
                  content: "File Name is required",
              })
              loading.value = false
            }
          }
        });
        loading.value = false
      }else{

        const formData = new FormData();

        formData.append('_method', 'PUT')
        formData.append('id', form.id)
        formData.append('file', form.file)
        formData.append('name', form.name)
        formData.append('invoice_id', invoice.id)
        if(form.description != null) {
          formData.append('description', form.description)
        }

        store.dispatch("InvoiceFile/update", {id: id, payload: formData}).then((response) => {
          visible.value = false
          loading.value = false
          invoice.invoice_files.find(function ( value:any,key:any) {
            if (value.id == response.data.id) {
              invoice.invoice_files[key] =  Object.assign({}, response.data);
            }
          })
        }).catch((err) => {
          loading.value = false
        })
      }

    }

    const isNew = computed(() =>
        router.name == 'InvoiceCreate'
    )
    return {
      form,
      document,
      file_name,
      headers: {
        authorization: 'authorization-text',
      },
      handlefile,
      create,
      cancel,
      save,
      edit,
      acceptedFiles,
      errors_obj,
      visible,
      form_action,
      invoice,
      id,
      api_url,
      loading
    };
  },
});
